import httpRequest from "app/lib/axios/index";

interface PresignedUrlParams {
  url: string;
  data: any;
}

export const getPresignedUrlsPromise = ({
  url,
  data,
}: PresignedUrlParams): Promise<any> => {
  return new Promise((resolve, reject) => {
    httpRequest
      .post(url, data)
      .then((response: any) => {
        resolve(response.data); // assuming the presigned URLs are in response.data
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
